// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponRedemptionListListResponse {
    static getAttributeTypeMap() {
        return CouponRedemptionListListResponse.attributeTypeMap;
    }
}
CouponRedemptionListListResponse.discriminator = undefined;
CouponRedemptionListListResponse.additionalProperties = false;
CouponRedemptionListListResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<CardTcsWrapperModelsClaimModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=couponRedemptionListListResponse.js.map